import { useQuery } from "@tanstack/react-query";

import { CREDENTIAL_PROVIDER_ID } from "lib/auth/accountProviders";
import { authClient, betterAuthErrorText } from "lib/auth/authClient";

/** One way the user can sign in: a password, a social provider or their company's SSO. */
export type BetterAuthAccount = {
  id: string;
  providerId: string;
  accountId: string;
  userId: string;
  issuer: string;
  scopes: string[];
  createdAt: Date;
  updatedAt: Date;
};

export const LIST_ACCOUNTS_QUERY_KEY = ["betterAuthAccounts"] as const;

export function useListAccounts() {
  return useQuery({
    queryKey: LIST_ACCOUNTS_QUERY_KEY,
    queryFn: async (): Promise<BetterAuthAccount[]> => {
      const { data, error } = await authClient.listAccounts();
      if (error) {
        throw new Error(betterAuthErrorText(error, "Could not load your sign-in methods"));
      }
      return data;
    },
  });
}

export function hasPasswordAccount(accounts: BetterAuthAccount[] | undefined): boolean {
  return !!accounts?.some((account) => account.providerId === CREDENTIAL_PROVIDER_ID);
}
